module.exports = __webpack_public_path__ + "img/survey-main.65ffd04.png";